import React from "react";
import Base3DButton from "./Base3DButton";
import { use3DButtonState } from "@/hooks/use3DButtonState";

interface ActivityButton3DProps {
  text: string;
  isCorrect?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  selected?: boolean;
  state?: "start" | "selected" | "incorrect" | "matched";
  width?: string;
  responsiveWidth?: boolean;
}

const ActivityButton3D: React.FC<ActivityButton3DProps> = ({ 
  text, 
  isCorrect,
  onClick,
  disabled = false,
  selected = false,
  state = "start",
  width = "220px",
  responsiveWidth = false
}) => {
  const { isAnimating, color, handleClick } = use3DButtonState(
    isCorrect,
    undefined,
    onClick
  );

  const handleButtonClick = () => {
    if (disabled || isAnimating) return;
    handleClick();
  };

  let buttonColor: "black" | "green" | "red" | "blue" = "black";
  if (state === "selected" || selected) {
    buttonColor = "blue";
  } else if (state === "matched") {
    buttonColor = "green";
  } else if (state === "incorrect") {
    buttonColor = "red";
  } else if (color !== "black") {
    buttonColor = color;
  }

  return (
    <Base3DButton
      onClick={handleButtonClick}
      disabled={disabled || isAnimating}
      color={buttonColor}
      isAnimating={isAnimating}
      width={width}
      responsiveWidth={responsiveWidth}
    >
      {text}
    </Base3DButton>
  );
};

export default ActivityButton3D; 